import { Entry, BaseModel, Form, Resource, EntryTypes, CardMode, TableButton } from '@ngx-resource-toolkit/core';
import { environment } from '../../../../environments/environment';
import { FormGroup } from '@angular/forms';
import { LigneFactureModel, calculMontantLigne } from './ligne-facture.model';
import { DateHelper } from '../../helpers/date.helper';
import { LeaResource } from '../../resource/lea.resource';
import { FormatHelper } from '../../helpers/format.helper';
import { TABLE } from '../../../app.constantes';

// edit-facture utilisé dans Administration->Factures

const onChanges = (value: FactureModel, form: FormGroup) => {
    // console.log('edit-facture FactureModel', 'onChanges', ' ' + form.controls['lignesFacture'].value.length, form);
    console.log('FactureModel', 'onChanges', ' ' + form.value['lignesFacture'].length);

    if (value.lignesFacture instanceof Array) {

        const m = value.lignesFacture.reduce((acc, curr, index, array) => {
            return acc + calculMontantLigne(curr, true);
        }, 0);

        form.patchValue({
            montantTotal : m
        }, { emitEvent: false });

    }
};

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/facturation',
            methods: LeaResource.methods,
        }
    }
})
@Form({
    'edit-facture': {
        onChanges
    },
    'create': {
        onChanges
    },
    'edit': {
        onChanges
    }
})
export class FactureModel extends BaseModel {

    @Entry({
        base: {
            hidden: true,
        },
        'edit-facture': {},
        'create': {},
        'edit': {}
    })
    _explicitType: string = 'Facture';

    @Entry({
        base: {
            hidden: true,
        },
        'edit-facture': {},
        'create': {},
        'edit': {}
    })
    id: string;

    @Entry({
        base: {
            hidden: true,
        },
        'edit-facture': {},
        'create': {},
        'edit': {}
    })
    anneeScolaire: string;

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            label: 'Famille',
            css: {
                group: 'col-xs-4'
            }
        },
        'edit-facture': {},
        'create': {},
        'edit': {},
        'table': {
        },
    })
    familleNom: string;

    @Entry({
        base: {
            hidden: true,
        },
        'edit-facture': {},
        'create': {},
        'edit': {},
    })
    idFamille: string;

    @Entry({
        base: {
            label: 'Période',
        },
        'edit-facture': {
            type: EntryTypes.STATIC,
            css: {
                group: 'col-xs-4'
            }
        },
        'create': {
            type: EntryTypes.STATIC,
            css: {
                group: 'col-xs-4'
            }
        },
        'edit': {
            type: EntryTypes.STATIC,
            css: {
                group: 'col-xs-4'
            }
        },
        'table': {
            type: EntryTypes.NUMBER,
            minWidth: TABLE.MIN_WIDTH.ID,
        }
    })
    periode: number;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-4'
            },
            options: [{
                value: true,
                label: 'Paiement comptant',
            }]
        },
        'edit-facture': {},
        'create': {},
        'edit': {}
    })
    isPaiementComptant: boolean;

    @Entry({
        base: {
            type: EntryTypes.DATE,
            format: 'x',
            formatDisplay: 'dd/mm/yyyy',
            label: 'Date facture',
        },
        'edit-facture': {
            css: {
                group: 'col-xs-6',
            },
            /* type: EntryTypes.STATIC,
            transform: (value) => DateHelper.timestampToDefault(value),*/
        },
        'create': {
            css: {
                group: 'col-xs-6',
            },
        },
        'edit': {
            css: {
                group: 'col-xs-6',
            }
        },
        'table': {
            minWidth: TABLE.MIN_WIDTH.DATE,
            transform: (value) => DateHelper.timestampToDefault(value),
        }
    })
    dateFacture: string;

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            css: {
                group: 'col-xs-6',
            },
            label: 'Numéro'
        },
        'table': {
            minWidth: TABLE.MIN_WIDTH.PAIEMENT_NUMERO,
        },
        'edit-facture': {
        },
        'edit': {},
        'create': {},
    })
    numeroFacture: string;

    @Entry({
        base: {
            label: 'Total facture',
        },
        'edit-facture': {
            type: EntryTypes.STATIC,
            css: {
                group: 'col-xs-6',
            },
            transform: (value) => FormatHelper.toChaineMonetaire(value, true),
        },
        'create': {
            type: EntryTypes.STATIC,
            css: {
                group: 'col-xs-6'
            },
        },
        'edit': {
            type: EntryTypes.STATIC,
            css: {
                group: 'col-xs-6'
            }
        },
        'table': {
            type: EntryTypes.TEXT,
            minWidth: TABLE.MIN_WIDTH.PAIEMENT_MONTANT,
            transform: (value) => FormatHelper.toChaineMonetaire(value),
        }
    })
    montantTotal: number;



    @Entry({
        base: {
            label: 'Lignes Facture',
        },
        'edit-facture': {
            type: EntryTypes.TABLE,
            columnMode: 'force',
            model: LigneFactureModel,
            removeCallback: (item: any, form) => {
                console.log('removeCallback');
                if (item.id) {
                    form.controls['removedLignesFacture'].value.push(item);
                }
            },
            addCallback: (item, form) => {
                console.log('addCallback', item, form);
                form.controls['typeLigne'].patchValue('M');
                form.controls['isManuel'].patchValue(true);
                form.controls['sens'].patchValue('F');
                form.controls['taux'].patchValue(100);
                item.getEntry('edit', 'sens').type = EntryTypes.RADIO;
            },
            /*actionCallback: (action: TableButton, row: BaseModel, form: FormGroup) => {
                switch (action) {
                    case TableButton.EDIT:
                        console.log('edit callback !!', action, row, form);
                        break;
                    case TableButton.CONSULT:
                        console.log('consult callback !!', action, row, form);
                        break;
                    case TableButton.DELETE:
                        console.log('delete callback !!', action, row, form);
                        break;
                    default:
                        console.log('default callback', action, row, form);
                        break;
                }
            }, // Défini dans create.component.ts/ngOnInit/registerEntryDynamicProperty*/
            css: {group: 'col-xs-12 lignes-facture'},
            buttons: [TableButton.ADD, TableButton.EDIT],
            // , TableButton.DELETE pas de delete ici, il faut aller sur la ligne pour la supprimer, c'est plus facile pour contrôler
            multiple: true,
        },
        'cards': {
            type: EntryTypes.CARDS,
            mode: CardMode.EDIT,
            model: LigneFactureModel,
            addLabel: 'Ajouter Ligne',
            title: 'Ligne Facture',
            removeCallback: (item, form) => {
                form.controls['removedLignesFacture'].value.push(item);
            },
            addCallback: (item, form) => {
                form.controls['typeLigne'].patchValue('M');
                form.controls['isManuel'].patchValue(true);
            },
            css: {
                box: 'panel panel-default col-xs-12 col-sm-6 col-md-4 col-lg-3',
            },
            multiple: true,
        },
        'create': {
            type: EntryTypes.TABLE,
            columnMode: 'force',
            model: LigneFactureModel,
            removeCallback: (item: any, form) => {
                if (item.id) {
                    form.controls['removedLignesFacture'].value.push(item);
                }
            },
            addCallback: (item, form) => {
                form.controls['typeLigne'].patchValue('M');
                form.controls['isManuel'].patchValue(true);
                form.controls['sens'].patchValue('F');
            },
            css: {group: 'col-xs-12 lignes-facture'},
            buttons: [TableButton.ADD, TableButton.DELETE],
            multiple: true,
        },
        'edit': {
            type: EntryTypes.TABLE,
            columnMode: 'force',
            model: LigneFactureModel,
            removeCallback: (item: any, form) => {
                if (item.id) {
                    form.controls['removedLignesFacture'].value.push(item);
                }
            },
            addCallback: (item, form) => {
                form.controls['typeLigne'].patchValue('M');
                form.controls['isManuel'].patchValue(true);
                form.controls['sens'].patchValue('F');
            },
            css: {group: 'col-xs-12 lignes-facture'},
            buttons: [TableButton.ADD, TableButton.DELETE],
            multiple: true,
        }
    })
    lignesFacture: LigneFactureModel[];

    @Entry({
        base: {
            hidden: true,
        },
        'edit-facture': {},
        'create': {},
        'edit': {}
    })
    removedLignesFacture: LigneFactureModel[];

    @Entry({
        base: {
            hidden: true,
        },
        'edit-facture': {},
        'create': {},
        'edit': {}
    })
    isValide: boolean;
    montantEscompte: string;
    totalApresEscompte: string;


    constructor(data) {
        super();
        Object.assign(this, data);

        this.setLignesFacture(data.lignesFacture);
        this.removedLignesFacture = [];
    }

    setLignesFacture(lignes) {
        this.lignesFacture = [];
        if (lignes instanceof Array) {
            lignes.forEach((ligne) => {
                this.lignesFacture.push(new LigneFactureModel(ligne));
            });
        }
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/facture/models/facture.model.ts